import { BaseModel } from '@tcc-mono/shared/data-access';
import { Animal } from './animal.model';

export type AnimalSelectionStatus = 'draft' | 'running' | 'success' | 'partial' | 'failed';

export type AnimalSelectionSource = 'rvo' | 'excel' | 'manual' | 'legacy' | 'kopie' | 'bright';

export class AnimalSelection extends BaseModel {
  id: number;
  /** @deprecated API v2 gebruikt remark */
  name?: string;
  remark?: string;
  status?: AnimalSelectionStatus;
  source?: AnimalSelectionSource;
  source_stable_id: number;
  source_stable_name?: string;
  source_stable_relation_name?: string;
  destination_stable_id?: number;
  destination_stable_name?: string;
  destination_stable_relation_name?: string;
  destination_hub_id?: number;
  destination_hub_name?: string;
  /** @deprecated API v2 */
  rvo_export?: string;
  /** @deprecated API v2 */
  rvo_passport?: string;
  /** @deprecated API v2 */
  rvo_transport?: string;
  /** @deprecated API v2 — gebruik status === 'success' */
  closed?: boolean;
  animal_count?: number;
  animals?: Animal[];
  created_at?: string;
  updated_at?: string;
  min_birth_date?: string | null;
  max_birth_date?: string | null;
  /** RVO dierSoort op de selectie (zelfde waarden als AnimalSpecies). */
  species?: string | null;
  use_rvo?: boolean;
  executed_at?: string | null;
}

export function animalSelectionDisplayName(
  selection: Pick<AnimalSelection, 'id' | 'remark' | 'name'> | null | undefined
): string {
  if (!selection) {
    return '';
  }
  const label = selection.remark ?? selection.name;
  return label?.trim() ? label.trim() : `Lijst #${selection.id}`;
}

export function animalSelectionIsLocked(selection: Pick<AnimalSelection, 'status' | 'closed'>): boolean {
  if (selection.status === 'success') {
    return true;
  }
  return selection.closed === true;
}

/** RVO-stal pull i.p.v. Excel-pool. */
export function animalSelectionUsesRvoPool(selection: Pick<AnimalSelection, 'source' | 'use_rvo'>): boolean {
  if (selection.source != null) {
    return selection.source !== 'excel';
  }
  return selection.use_rvo !== false;
}

export function animalSelectionStatusLabel(status?: AnimalSelectionStatus): string {
  switch (status) {
    case 'success':
      return 'Afgesloten';
    case 'running':
      return 'Bezig';
    case 'partial':
      return 'Gedeeltelijk';
    case 'failed':
      return 'Mislukt';
    case 'draft':
    default:
      return 'Open';
  }
}
